
import React, { PureComponent } from 'react';

import Request from "../../networkReq/request";
import Http from "../../networkReq/http"
import { Base64 } from 'js-base64';
import {getUrlParam ,createUUID} from '../../utils/methods'
import { getRecord, setRecord, setClickInfo, getClickInfo,setApplicationSessionId , getApplicationSessionId } from '../../utils/storage';

import md5 from 'js-md5';
import {
    setToken,
    setCurrentUser,
    setUserId,
    setCaptchaKey
} from 'utils/storage';

export default class sso extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            sessionid:""
        };

    }
    componentDidMount() {  
        /**
         * 1、判断是够从第三方应用跳转过来
         */
        let clickInfo={
            //应用key
            clientId:"",
            //回传参数
            goto:"",
            //用户类型 0、自然人 1、法人 
            utype:"",
            //跳转类型 1、登录  2、跳转
            action:"",
            //终端类型： 1、应用管理 2 、终端 3、门户 4、 app
            terminaltype:""
        }

        //判断是否是对接系统跳转过来
        let urlparam=this.props.location.search;
        if (urlparam&&getUrlParam("client_id",urlparam)) {
            clickInfo.clientId =getUrlParam("client_id",urlparam);
            clickInfo.goto =getUrlParam("goto",urlparam);
            clickInfo.utype =getUrlParam("utype",urlparam);
            clickInfo.action =getUrlParam("action",urlparam);
            clickInfo.terminaltype =getUrlParam("terminaltype",urlparam);
            /*
            1、判断用户是否以及在一体化门户登录
            2、1）如果一体化门户没有登录、则把client_id 和goto信息保存到页面缓存、再跳转到政务网、
               2）政务网登录后、信息回传到一体化门户、首先一体化门户做自动登录、再把数据post、get 把数据给到第三方应用
            3、如果一体化门户登录、整一体化门户把数据直接post过去
            */
            setClickInfo(clickInfo);
        }
        // 开发环境配置
        console.log("=======clickInfo=========",clickInfo);
        if(window.location.hostname=="localhost"||window.location.hostname=="yhbest.imwork.net"){
           

            let record1={};
            record1.uuid="60a3";
            if (clickInfo&&clickInfo.clientId) {
                this.login(record1, this.callbackSys,clickInfo);
            } else {    
                this.login(record1);
            }
            return;
        }
      
        
        let sessionid = "";
        let record = getRecord();

        if (urlparam&&getUrlParam("sessionid",urlparam)) {
            sessionid =getUrlParam("sessionid",urlparam);
        }
         if(!clickInfo.clientId){
             clickInfo= getClickInfo();
             setClickInfo({});
         }
         console.log("=======clickInfo=========",clickInfo);
        //如果没有记录，并且是第三方跳转过来的 则直接跳转到政务网单点登录
        if (clickInfo&&clickInfo.clientId && !record) {
            this.tologinPage(clickInfo);
            return;
        } else if (!record && !sessionid) {
            this.props.history.push('/entrance/home');
            return;
        }
        console.log("=================record:", record);
        
        /**
         * 2、判断是否从门户端跳转登录页
         */

        //如果浏览器没有记录，sessid有数据， 则已sessionid登录
        if (!record&&sessionid) {
            record.uuid = sessionid;
            record.url = "/entrance/home";
            setRecord(record);
        }
        
     
        // this.setState({sessionid:record.uuid});
        
        /**
         * 3、登录跳转
         */
        if (record ) {
            if (record && sessionid && record.uuid != sessionid) {
                record.uuid = sessionid;
                setRecord(record);
            }

            //本地测试参数(删除环境要删除)==============================
            if(window.location.hostname=='yhbest.imwork.net'||window.location.hostname=='127.0.0.1'||window.location.hostname=='localhost'){
                record.url = '/entrance/home'
                record.uuid = "60a3";
                setRecord(record);
            }
          
            //本地测试参数(删除环境要删除)==============================
            
            //如果是第三方跳转过来的 则post请求到第三方页面
            console.log("=============登录判断============",clickInfo);
            if (clickInfo&&clickInfo.clientId) {
                this.login(record, this.callbackSys,clickInfo);
            } else {    
                this.login(record);
            }
            return;
        }

        this.props.history.push('/entrance/home');
    }
    //自动登录
    login(record, callback,clickInfo) {
        let params = {};
        params.uuid = record.uuid;
        params.grant_type = "sso";
        return Http.ssoLogin(Request.getLogin(), params, obj => {
            this.setState({
                loading: false
            })
            if(obj==-1){
                this.tologinPage();
                return;
            }
            if (obj.error) {
                this.tologinPage();
                return;
                // this.props.history.push('/entrance/home');
               
            } else {
                if (obj.access_token) {
                    setToken(obj.access_token);
                    setCurrentUser(obj);
                    setUserId(obj.user_id);
                    this.setState({
                        loading: false
                    })
                    console.log("=============登录成功判断=========");
                    if (callback) {
                        return callback(clickInfo);
                    }
                    if (record.url) {
                        this.props.history.push(record.url)
                    } else {
                        this.props.history.push('/entrance/home')
                    }
                }
            }
        });
    }
    //跳转到门户
    callbackSys=(data)=> {
      let {sessionid}=this.state;
        let clickInfo=  data;
        console.log("=========clickInfo==========",clickInfo);

        setClickInfo(null);
    /**
     * 1、获取当前登录用户的信息(加密)
     * 2、把参数post请求过去
     */
    
     let terminaltype="2"
     if(clickInfo&&(clickInfo.terminaltype=="2"||clickInfo.terminaltype=="3"||clickInfo.terminaltype=="4")){
         terminaltype=clickInfo.terminaltype
     }
     clickInfo.terminaltype=terminaltype;
     clickInfo.sessionid=sessionid;
     let param={
        clientId:clickInfo.clientId,
        terminaltype:terminaltype
     }
     Http.postFrom(Request.getUserEncryption(),param,(response)=>{
          console.log("=====getUserEncryption=======",response);
          if(response.data&&response.data.tokenUrl){
            clickInfo.assertion=response.data.assertion;
            clickInfo.homeurl=response.data.url;
            let tokenUrl=response.data.tokenUrl;
            if(window.location.hostname=='127.0.0.1'||window.location.hostname=='localhost'){
                clickInfo.homeurl='http://localhost:3001/tyjrby/sso'
                tokenUrl="http://localhost:3001/tyjrby/api/swsmart-system/applicationmanag/sso/oauthDecrypt"
            }
         
            Http.simplePost(tokenUrl, clickInfo);
          }else{
             window.location='/entrance/home';
          }
          
     })
     
        // Http.simplePost("http://127.0.0.1/swsmart-system/applicationmanag/sso/test", clickInfo);
        // window.location="url";

    }

    //跳转到门户端
    tologinPage(clickInfo) {
        let { zwwcom, zwwlogin, clientId,zwwRegister } = Request.getZwwConfig();
        let goto = {};
        goto.url = '/entrance/home'
        goto.uuid =createUUID(); //"60a3" ;//createUUID(); // "c6c688934755610ae060ac2c" //本地测试
        let gototmp = JSON.stringify(goto);
        let gotoencode = Base64.encode(gototmp);
        setRecord(goto);
        let path="";
        if(clickInfo&&clickInfo.action=="1"){
            path=zwwlogin;
        }else if(clickInfo&&clickInfo.action=="2"){
            path=zwwRegister;
        }else{
            path=zwwlogin; 
        }
        let  utype="";
        if(clickInfo&&(clickInfo.utype=="0"||clickInfo.utype=="1")){
            utype=clickInfo.utype
        }else{
            utype="0";
        }
        window.location = zwwcom + path + "?utype="+utype+"&goto=" + gotoencode + "&client_id=" + clientId;
    }
    render() {
        return null;
    }
}